import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Ambulatorio = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="SETORES DO AMBULATÓRIO" />
                    <div style={{ textAlign: "left" }}>

                        <Input label="Nome do Setor" nome="nomeambu" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="49vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Número de Setores" nome="leitos" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Demanda Reprimida no Setor" nome="demandaambu" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    </div>

                    <HeaderVerde texto="FISIOTERAPEUTAS QUE TRABALHAM NO SETOR" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantos Fisioterapeutas no Setor" nome="setorambu" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdFisio()}
                    </div>

                    <HeaderVerde texto="ÁREA DE ATUAÇÃO" />
                    <CheckContainer>
                        <CheckBox texto="DTM" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Vascular" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Pediatria" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Aquática" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Oncologia" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Obstetrícia" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Neurologia" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Acupuntura" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Equoterapia" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Gerontologia" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Reumatologia" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Terapia Manual" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Dermatofuncional" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Traumato-Ortopedia" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Fisioterapia do Trabalho" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Respiratória/Cadiovascular" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Uro/Gineco/PRoctologia" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Outros" grupo="ambuarea" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>

                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="CONFORMIDADE COM A RESOLUÇÃO COFFITO Nº 387/2011 e Nº 444/2014" nome="resolucao387" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa >
            )

            function RenderQtdFisio() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["setorambu"]
                if (array[modulo][n]["setorambu"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                            
                                <Input label="Profissional" nome="profissionalambu" modulo={modulo} index={n}
                                    subModulo="profissionalnalambu" indexSub={i} componentDisplay="inline-grid" widthWeb="30vw"
                                    widthMobile="80vw" marginR="3vw" />

                                <Input label="Inscrição" nome="inscricaoambu" modulo={modulo} index={n} subModulo="inscricaoambu"
                                    indexSub={i} componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw" />

                                <Select label="Jornada de Trabalho" nome="ambujornada" modulo={modulo} index={n}
                                    subModulo="ambujornada" indexSub={i} componentDisplay="inline-grid" widthWeb="14vw"
                                    widthMobile="80vw" marginR="3vw" array={["Diarista", "Plantonista", "Ambos"]} />

                                <Select label="Horário de Trabalho" nome="ambuhrtrabalho" modulo={modulo} index={n}
                                    subModulo="ambuhrtrabalho" indexSub={i} componentDisplay="inline-grid" widthWeb="14vw"
                                    widthMobile="80vw" marginR="3vw" array={["12h diurno", "12h noturno", "6h matutino", "6h vespertino", "6h noturno", "24 horas"]} />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}

export default Ambulatorio